
// BEGIN: custom code for N&C

// wrap image with link from column in multicolumn
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.multicolumn-card').forEach(card => {
        const link = card.querySelector('.link.animate-arrow'); // Get the link
        const imageWrapper = card.querySelector('.multicolumn-card__image-wrapper'); // Get the image wrapper

        if (link && imageWrapper) {
            const href = link.getAttribute('href'); // Get the link's href
            if (href) {
                // Set the href on the image wrapper
                imageWrapper.style.cursor = 'pointer';
                imageWrapper.addEventListener('click', () => {
                    window.location.href = href; // Redirect to the link on click
                });
            }
        }
    });
});

// fix variant images options
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-form__input').forEach(fieldset => {
    const legend = fieldset.querySelector('.form__label');
    const optionLabel = legend.querySelector('.color_swatch_option_label');
    const inputs = fieldset.querySelectorAll('input[type="radio"]');

    inputs.forEach(input => {
      input.addEventListener('change', () => {
        // Get the currently selected value
        const selectedValue = fieldset.querySelector('input[type="radio"]:checked').value;

        // Update the legend text dynamically
        if (optionLabel) {
          legend.innerHTML = `<span class="color_swatch_option_label">${optionLabel.textContent}</span> ${selectedValue}`;
        }
      });
    });
  });
});

// manage shade over content when megamanu opens
document.addEventListener('DOMContentLoaded', function () {
  const body = document.body;
  const menuDetails = document.querySelectorAll('.mega-menu'); // All <details> elements
  const menuOverlay = document.getElementById('menu-overlay');

  menuDetails.forEach(menu => {
    menu.addEventListener('toggle', function () {
      if (menu.open) {
        body.classList.add('mega-menu-open');
        menuOverlay.style.opacity = '1'; // Ensure visibility for JS-controlled fallback
        menuOverlay.style.pointerEvents = 'auto';
        menuOverlay.style.display = 'block'; // Force display for testing
      } else if (!Array.from(menuDetails).some(menu => menu.open)) {
        body.classList.remove('mega-menu-open');
        menuOverlay.style.opacity = '0'; // Ensure fade-out for JS-controlled fallback
        menuOverlay.style.pointerEvents = 'none';
      }
    });
  });

  menuOverlay.addEventListener('click', function () {
    menuDetails.forEach(menu => (menu.open = false));
    body.classList.remove('mega-menu-open');
    menuOverlay.style.opacity = '0'; // Ensure fade-out for JS-controlled fallback
    menuOverlay.style.pointerEvents = 'none';
    menuOverlay.style.display = 'none'; // Force hide for testing
  });
});

// make soclial links open in new target
document.querySelectorAll('a.link.list-social__link').forEach(function(link) {
  link.setAttribute('target', '_blank');
  link.setAttribute('rel', 'noopener noreferrer');
});

/******************************************************************************
 *  CUZEZ CUSTOM JS
 *  Restores variant-color image filtering for product gallery
 *  Update-proof, compatible with all Dawn versions
 ******************************************************************************/

document.addEventListener("DOMContentLoaded", () => {
  const configEl = document.querySelector('#cuzez-variant-config');
  if (!configEl) return;

  const config = JSON.parse(configEl.textContent);
  const { sectionId, productHandle, optionsToWatch } = config;

  const mediaGallery =
    document.querySelector('media-gallery') ||
    document.querySelector('product-media-gallery');

  const productSection =
    document.querySelector(".product-variant-id") ||
    document.querySelector("variant-selects") ||
    document.querySelector("variant-radios") ||
    document.querySelector("form[action='/cart/add']");

  if (!mediaGallery || !productSection) {
    console.error("Gallery or product variant container missing.");
    return;
  }

  /***************************************************************************
   * STEP 1: Fetch full product JSON from Shopify native endpoint
   ***************************************************************************/
  const handle = `products/${productHandle}.js`;

  fetch(`${window.Shopify.routes.root}${handle}`)
    .then(response => response.json())
    .then(product => {
      const optionNames = optionsToWatch.split(",").map(s => s.trim());
      const colorOption =
        product.options.find(opt => optionNames.includes(opt.name)) || null;

      if (!colorOption) {
        console.warn("Color option not found in product data.");
        return;
      }

      /*************************************************************************
       * STEP 2: Map colors to the ranges of images belonging to each color
       *************************************************************************/
      const colorValues = colorOption.values;
      const colorImagePositions = {};

      // Map each color to its FIRST image position
      colorValues.forEach(color => {
        const variant = product.variants.find(
          v => v.options[colorOption.position - 1] === color
        );
console.log("cuzez color: " + variant);
        if (variant && variant.featured_image) {
          colorImagePositions[color] = variant.featured_image.position;
        }
      });

      // Sort colors by image position
      const sortedColors = Object.entries(colorImagePositions).sort(
        (a, b) => a[1] - b[1]
      );

      const colorImageRanges = {};

      sortedColors.forEach((entry, index) => {
        const colorName = entry[0];
        const startPos = entry[1];
        const nextPos = sortedColors[index + 1]
          ? sortedColors[index + 1][1]
          : null;

        colorImageRanges[colorName] = nextPos
          ? [startPos, nextPos]
          : [startPos];
      });

      /*************************************************************************
       * STEP 3: Convert ranges into actual media IDs for each color group
       *************************************************************************/
      const colorImageIDs = {};

      Object.entries(colorImageRanges).forEach(([color, range]) => {
        const start = range[0];
        const end = range[1] || product.media.length + 1;

        const ids = product.media
          .filter((media, index) => {
            const pos = index + 1;
            return pos >= start && pos < end;
          })
          .map(media => media.id);

        colorImageIDs[color] = ids;
      });

      /*************************************************************************
       * STEP 4: Assign data-media-group attributes in the DOM
       *************************************************************************/
      Object.entries(colorImageIDs).forEach(([color, ids]) => {
        ids.forEach(mediaID => {
          const selectors = [
            `[data-media-id="${sectionId}-${mediaID}"]`,
            `[data-target="${sectionId}-${mediaID}"]`
          ];

          selectors.forEach(sel => {
            mediaGallery.querySelectorAll(sel).forEach(item => {
              item.setAttribute("data-media-group", color);
            });
          });
        });
      });

      /*************************************************************************
       * STEP 5: Show/hide images when the selected color changes
       *************************************************************************/
      const showVariantImages = () => {
        // Find selected variant options (radio or select)
        const picked = Array.from(
          document.querySelectorAll(
            'select option[selected], fieldset input[type="radio"]:checked'
          )
        ).map(el => el.value);

        // Which picked value is a color?
        const selectedColor = picked.find(value =>
          Object.keys(colorImageRanges).includes(value)
        );

        if (!selectedColor) return;

        // Hide/show groups
        mediaGallery.querySelectorAll('[data-media-group]').forEach(item => {
          const group = item.getAttribute("data-media-group");
          if (group === selectedColor) {
            item.classList.remove("hidden");
          } else {
            item.classList.add("hidden");
          }
        });

        // Re-init Dawn slider if present
        mediaGallery
          .querySelectorAll("slider-component")
          .forEach(slider => slider.initPages && slider.initPages());
      };

      /*************************************************************************
       * STEP 6: Initial call + attach listeners
       *************************************************************************/
      showVariantImages();
      productSection.addEventListener("change", showVariantImages);
      document.addEventListener("product:variant-change", showVariantImages);
    })
    .catch(err => console.error("Product JSON fetch failed:", err));
});
// END: custom code for N&C